export const BRAND = {
  name: "Eath's",
  logo: "/logo/eaths-logo.webp",
};
